define('views/modules/template/assignment/list/template-select-list-item',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/i18n',
    // parent view
    'views/modules/template/list/template-list-item',
    // views
    'views/parts/media-info-box',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    i18n,
    // parent view
    VTemplateListItem,
    // views
    VMediaInfoBox
) {

    var VTemplateSelectListItem = VTemplateListItem.extend({
        className: 'template-select-list-item',

        initialize: function(opt) {
            this.view = {
                infobox: new VMediaInfoBox({
                    title: 'name',
                    subtitle: 'description',
                    model: this.model,
                    context: this,
                    onClick: this.onClick,
                    menu: false
                }),
            };
        },

        setActive: function(val) {
            this.$el.toggleClass('active', val);
        },

        isActive: function() {
            return this.$el.hasClass('active');
        },

        ////////////
        // events //
        ////////////
        onClick: function(e) {
            var isActive = !this.isActive();
            this.model.trigger('template:click', this.model, isActive);
            this.setActive(isActive);
        },

    });

    return VTemplateSelectListItem;

});

